export const IDEAS_PORTAL_ACCESS_KEY = 'ideasPortalAccess';
export const IDEAS_PORTAL_APPLICATION_KEY = 'application';

export function getIdeasPortalAccessKey() {
  return `${IDEAS_PORTAL_APPLICATION_KEY}:${IDEAS_PORTAL_ACCESS_KEY}`;
}
